module.exports = __webpack_public_path__ + "a1ec3c26677d8741472aeaa8876c28d4.MP3";